import { ReactElement, ReactNode } from 'react';
import { FormItemProps, Form as AntForm } from 'antd';
import { DataTestIdProxy } from 'common/components/Utilities/DataTestIdProxy';

export const FormItem = ({
  dataTestId,
  children,
  rootClassName,
  ...restProps
}: FormItemProps & {
  dataTestId?: string;
  children?: ReactNode;
}): ReactElement => (
  <DataTestIdProxy dataTestId={dataTestId}>
    <AntForm.Item colon={false} rootClassName={['custom-ant-form-item', rootClassName].join(' ')} {...restProps}>
      {children}
    </AntForm.Item>
  </DataTestIdProxy>
);
